import markerImage from '@/libs/cesiumExtents/Assets/Images/marker.png'
import CesiumPlus from '@/libs/cesiumExtents/CesiumPlus'

const defaultPointStyle = {
  'color': '#FF0000FF',
  'enableAggregation': false,
  'enableLegend': false,
  'icon': '1',
  'label': 'empty',
  'layerId': 0,
  'radius': 40,
  'size': 'MIDDLE',
  'type': 'SCATTER_PLOT',
  'heatColor': 'color1',
  'isHover': false,
  'labelStyle': {
    labelBackgroundColor: '#272829FF',
    labelColor: '#FFFFFF',
    labelFont: '黑体'
  }
}
const defaultLineStyle = {
  'color': '#1890FFFF',
  'dynamicEffect': 'empty',
  'height': 100,
  'label': 'empty',
  'layerId': 0,
  'linear': 'solid',
  'texture': 'empty',
  'type': 'COMMON',
  'width': 4,
  'isHover': false,
  'labelStyle': {
    labelBackgroundColor: '#272829FF',
    labelColor: '#FFFFFF',
    labelFont: '黑体'
  }
}
const defaultPolygonStyle = {
  'fillColor': '#1890FF33',
  'id': 0,
  'label': 'empty',
  'outlineColor': '#1890FFFF',
  'outlineWidth': 4,
  'isHover': false,
  'labelStyle': {
    labelBackgroundColor: '#272829FF',
    labelColor: '#FFFFFF',
    labelFont: '黑体'
  }
}
// 标注UI弹窗样式
const actionUIType = [
  { id: 'none', name: '无弹窗' },
  { id: 'default', name: '默认弹窗' },
  { id: 'html', name: '图文弹窗' },
  { id: 'live', name: '直播弹窗' }
]
// 热力图配色方案
const heatMapColorConfig = [
  {
    id: 'color1',
    value: [{ color: 'blue', value: 0.3 }, { color: 'yellow', value: 0.65 }, { color: 'orange', value: 0.8 }, { color: 'red', value: 0.95 }]
  },
  {
    id: 'color2',
    value: [{ color: '#0C00F5', value: 0.2 }, { color: '#00F7FB', value: 0.4 }, { color: '#39FF00', value: 0.6 }, { color: '#FDEB00', value: 0.8 }, { color: '#F81E13', value: 0.95 }]
  },
  {
    id: 'color4',
    value: [{ color: '#12923A', value: 0.2 }, { color: '#95C85A', value: 0.4 }, { color: '#F7F5B0', value: 0.6 }, { color: '#FCB369', value: 0.8 }, { color: '#DB2E26', value: 0.95 }]
  },
  {
    id: 'color5',
    value: [{ color: '#BBF0D2', value: 0.2 }, { color: '#34ECD6', value: 0.4 }, { color: '#F1E096', value: 0.6 }, { color: '#F6958A', value: 0.8 }, { color: '#F43449', value: 0.95 }]
  }
]
const markerIconsConfig = {}
function getIconData (id) {
  const groupKey = ['STEREO', 'FLAT', 'PERSONAL']
  for (let i = 0; i < groupKey.length; i++) {
    const icons = markerIconsConfig[groupKey[i]]
    for (let j = 0; j < icons.length; j++) {
      if (icons[j].id.toString() === id.toString()) {
        const icon = JSON.parse(JSON.stringify(icons[j]))
        if (icon.module === 'STEREO') {
          icon.url = '/static/textures/icon/group1/' + icon.url
        } else if (icon.module === 'FLAT') {
          icon.url = '/static/textures/icon/group2/' + icon.url
        }
        return icon
      }
    }
  }
  return {
    id: '',
    name: 'default',
    renderType: 'COLOR',
    url: markerImage
  }
}
function adapterPointStyle (data) {
  if (data.type === 'SCATTER_PLOT') {
    const scales = {
      'SMALL': 0.8,
      'MIDDLE': 1.0,
      'BIG': 1.2
    }
    const scale = scales[data.size]
    const icon = getIconData(data.icon)
    return new CesiumPlus.BillboardStyle({
      image: icon ? icon.url : markerImage,
      scale: scale,
      width: 30,
      height: 30,
      color: icon && icon.renderType === 'COLOR' ? Cesium.Color.fromCssColorString(data.color) : Cesium.Color.WHITE,
      isCluster: data.enableAggregation
    })
  } else {
    const gradient = {}
    for (let i = 0; i < heatMapColorConfig.length; i++) {
      if (heatMapColorConfig[i].id === data.heatColor) {
        const item = heatMapColorConfig[i].value
        for (let j = 0; j < item.length; j++) {
          gradient[item[j].value.toString()] = item[j].color
        }
      }
    }
    return new CesiumPlus.HeatStyle({
      radius: data.radius,
      gradient: gradient
    })
  }
}
function adapterLineStyle (data) {
  if (data.type === 'COMMON') {
    if (data.linear === 'solid') {
      return new CesiumPlus.PolylineStyle({
        material: Cesium.Color.fromCssColorString(data.color),
        width: data.width
      })
    } else if (data.linear === 'dash') {
      return new CesiumPlus.PolylineStyle({
        material: new Cesium.PolylineDashMaterialProperty({
          color: Cesium.Color.fromCssColorString('#ffffff00'),
          gapColor: Cesium.Color.fromCssColorString(data.color),
          dashLength: 32,
          dashPattern: 64
        }),
        width: data.width
      })
    } else if (data.linear === 'arrow') {
      return new CesiumPlus.PolylineStyle({
        material: new Cesium.PolylineArrowMaterialProperty(Cesium.Color.fromCssColorString(data.color)),
        width: data.width
      })
    }
  } else if (data.type === 'WALL') {
    const horizontalSpeed = data.dynamicEffect === 'horizontal' ? 100 : 0
    const verticalSpeed = data.dynamicEffect === 'vertical' ? 100 : 0
    let texture = require('../libs/cesiumExtents/Assets/Textures/baise.png')
    if (data.texture === 'arrow') {
      texture = require('../libs/cesiumExtents/Assets/Textures/jiantou.png')
    } else if (data.texture === 'line') {
      texture = require('../libs/cesiumExtents/Assets/Textures/xiantiao.png')
    } else {
      texture = require('../libs/cesiumExtents/Assets/Textures/baise.png')
    }
    return new CesiumPlus.WallStyle({
      material: new Cesium.WallCommonMaterailProperty({
        color: Cesium.Color.fromCssColorString(data.color),
        horizontalSpeed: horizontalSpeed,
        verticalSpeed: verticalSpeed,
        horizontalRepeat: 12,
        image: texture
      }),
      maximumHeights: data.height
    })
  }
}
function adapterPolygonStyle (data) {
  return new CesiumPlus.PolygonStyle({
    material: Cesium.Color.fromCssColorString(data.fillColor),
    outlineWidth: data.outlineWidth,
    outlineMaterial: Cesium.Color.fromCssColorString(data.outlineColor)
  })
}

function getDefaultStyle (type) {
  if (type === 'POINT') {
    return adapterPointStyle({
      'color': '#FF0000',
      'enableAggregation': false,
      'enableLegend': false,
      'icon': 'default',
      'label': 'empty',
      'layerId': 0,
      'radius': 40,
      'size': 'MIDDLE',
      'type': 'SCATTER_PLOT',
      'heatColor': 'color1'
    })
  } else if (type === 'LINE') {
    return adapterLineStyle(defaultLineStyle)
  } else if (type === 'PLANE') {
    return adapterPolygonStyle(defaultPolygonStyle)
  }
}

export {
  defaultPointStyle,
  defaultLineStyle,
  defaultPolygonStyle,
  heatMapColorConfig,
  markerIconsConfig,
  actionUIType,
  getIconData,
  adapterPointStyle,
  adapterLineStyle,
  adapterPolygonStyle,
  getDefaultStyle
}
